<template>
  <div>
    <div class="card-date-container iqos-group-item">
      <hr class="date-hr">
      <span class="date-badge c-grey">
        {{ card.created_at | formatDate }}
      </span>
    </div>
    <div
      :class="{
      'changelog-card-wrapper': true,
      'iqos-group-item': true,  
      'card-warning': card.priority == 'medium',
      'card-critical': card.priority == 'high'
    }"
    >
      <h3 class="changelog-card-title">{{card.title}}</h3>
      <img :src="card.image" class="changelog-card-image iqos-group-item" v-if="card.image" />

      <div class="changelog-card-content" v-html="card.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: Object,
  },
};
</script>

<style scoped>
.changelog-card-wrapper {
  /* border: 1px solid #ededed; */
  border-radius: 1.3vh;

  padding: 2vh;

  background: #1d1d1b;
  color: #ededed;
}

.changelog-card-title {
  font-size: 3vh;
}

.changelog-card-image {
  border-radius: 1.3vh;
  width: 100%;
}

.changelog-card-content {
  margin-top: 1.65vh;
}

.card-date-container {
   height: 1vh;
}

.card-warning {
  border: 1px solid #ffd2a8;
}

.card-critical {
  border: 1px solid #e2223b;
}

.date-hr {
  border: none;
  border-top: 1px solid #A4A3A1;
  margin: 0;
   
    
}

.date-badge  {
  background-color: #464646;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  padding: 0 1vh;
  width: fit-content;
  min-width: 14vh;
  text-align: center;
  transform: translateY(-50%);
}

.card-date-container {
  position: relative;
}
</style>